export default __webpack_public_path__ + "static/media/earplugs-bird.10113bca.png";